import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette, faTimes } from '@fortawesome/free-solid-svg-icons';

const ThemeToggle = () => {
  const { backgroundColor, changeBackgroundColor } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const themes = [
    { value: 'black', label: 'Black', color: '#000000' },
    { value: 'grey', label: 'Grey', color: '#1a1a1a' },
    { value: 'white', label: 'White', color: '#ffffff' }
  ];

  const handleThemeChange = (theme) => {
    console.log('🎨 Theme button clicked:', theme);
    const success = changeBackgroundColor(theme);
    if (success) {
      console.log('✅ Theme changed successfully to:', theme);
      setIsOpen(false);
    } else {
      console.error('❌ Failed to change theme to:', theme);
    }
  };

  const getPanelBackgroundColor = () => {
    return backgroundColor === 'white' ? '#f5f5f5' : '#2a2a2a';
  };

  const getPanelBorderColor = () => {
    return backgroundColor === 'white' ? '#ddd' : '#444';
  };

  const getTextColor = () => {
    return backgroundColor === 'white' ? '#000' : '#fff';
  };

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => {
          console.log('🎨 Palette button clicked, opening menu. Current state:', !isOpen);
          setIsOpen(!isOpen);
        }}
        title="Change page theme"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          backgroundColor: '#FFB6C1',
          color: '#000',
          border: 'none',
          cursor: 'pointer',
          fontSize: '1.5rem',
          boxShadow: '0 4px 12px rgba(255, 182, 193, 0.3)',
          zIndex: 10000,
          transition: 'all 0.3s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(255, 182, 193, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 182, 193, 0.3)';
        }}
      >
        <FontAwesomeIcon icon={isOpen ? faTimes : faPalette} />
      </button>

      {/* Theme Selector Panel */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            bottom: '90px',
            right: '20px',
            backgroundColor: getPanelBackgroundColor(),
            border: `1px solid ${getPanelBorderColor()}`,
            borderRadius: '12px',
            padding: '20px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
            zIndex: 10000,
            minWidth: '220px'
          }}
        >
          <h3
            style={{
              margin: '0 0 15px 0',
              fontSize: '1rem',
              color: getTextColor(),
              fontWeight: '600'
            }}
          >
            Choose Theme
          </h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {themes.map((theme) => {
              const isSelected = backgroundColor === theme.value;
              return (
                <button
                  key={theme.value}
                  onClick={() => handleThemeChange(theme.value)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '12px 16px',
                    backgroundColor: isSelected 
                      ? 'rgba(255, 182, 193, 0.2)' 
                      : 'transparent',
                    border: isSelected 
                      ? '2px solid #FFB6C1' 
                      : `1px solid ${getPanelBorderColor()}`,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    color: getTextColor()
                  }}
                  onMouseEnter={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.backgroundColor = backgroundColor === 'white' 
                        ? '#f0f0f0' 
                        : '#333';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }
                  }}
                >
                  <div
                    style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: theme.color,
                      border: '2px solid #666',
                      flexShrink: 0
                    }}
                  />
                  <span style={{ fontSize: '0.95rem', fontWeight: '500', flex: 1 }}>
                    {theme.label}
                  </span>
                  {isSelected && (
                    <span style={{ color: '#FFB6C1', fontWeight: 'bold', fontSize: '1.2rem' }}>✓</span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default ThemeToggle;
